// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {useRef, useEffect, useState, RefObject} from 'react';
import cn from 'classnames';
import {use_click_outside} from '../../../../hola/pub/lib/use_click_outside';
import styles from './popup.module.less';

// XXX sergey: typescript missing those props
export type LintHTMLDialogElement = HTMLDialogElement & {
    close: ()=>any,
    show: ()=>any,
};

type t_popup_props = {
    wrapper_cls?: string;
    button_cls?: string;
    button_text?: React.ReactNode;
    popup_cls?: string;
    children?: React.ReactNode;
    show_on_hover?: boolean;
    is_always_shown?: boolean;
    position?: 'left' | 'center' | 'right' | 'right_top' | 'top' | 'bottom';
    on_toggle?: (ev?: MouseEvent)=>void;
    popup_ref?: RefObject<LintHTMLDialogElement>;
    button?: React.ReactNode;
    close_on_item_click?: boolean;
};

export const Popup = (props: t_popup_props)=>{
    const {button_cls, button_text, popup_cls, children, wrapper_cls, button,
        on_toggle, show_on_hover, position = 'left', is_always_shown} = props;
    const [is_open, set_is_open] = useState(is_always_shown ?? false);
    const wrapper_ref = useRef<HTMLDivElement>();
    const ref = useRef<LintHTMLDialogElement>(null);
    const popup_ref = props.popup_ref || ref;
    const show_popup = ()=>{ set_is_open(true); };
    const hide_popup = ()=>{
        if (is_always_shown)
            return;
        set_is_open(false);
    };
    const toggle_popup = ev=>{
        if (is_always_shown)
            return;
        if (on_toggle)
            on_toggle(ev);
        set_is_open(v=>!v);
    };
    useEffect(()=>{
        if (is_always_shown)
            popup_ref.current.show();
        if (is_open)
            popup_ref.current.show();
        else
            popup_ref.current.close();
    }, [is_open, is_always_shown]);
    use_click_outside(popup_ref, ()=>{
        if (is_always_shown)
            return;
        popup_ref.current.close();
        set_is_open(false);
    });
    const btn = button ? button :
        <button className={cn(button_cls, styles.button)}
          type="button"
          onClick={show_on_hover ? undefined : toggle_popup}>
          {button_text}
        </button>;
    return <div ref={wrapper_ref}
      className={cn(wrapper_cls, styles.popup_wrapper)}
      onMouseOver={show_on_hover ? show_popup : undefined}
      onMouseLeave={show_on_hover ? hide_popup : undefined}>
      {btn}
      <dialog ref={popup_ref}
        onClick={ev=>{
          ev.stopPropagation();
          if (props.close_on_item_click)
            hide_popup();
        }}
        className={cn(popup_cls, styles.popup, styles[position])}>
        {children}
      </dialog>
    </div>;
};
